<div class="row mb-2">
  <div class="col-12 col-md-4">
    <div class="card">
      <div class="card-header bg_blue">
        <span class="c_white mb-3"><i class="fas fa-fw fa-print me-2"></i>Reports</span>
      </div>
      <div class="card-body bg_bluelt">
        <div class="my-2">
          <a href="https://reporting.welara.com/hourglass_export.aspx" target="_blank"><i class="fas fa-fw fa-print me-2"></i>Hourglass Data Export by Client/Date</a>
        </div>
        <div class="my-2">
          <a href="https://reporting.welara.com/hourglass_export_resource.aspx" target="_blank"><i class="fas fa-fw fa-print me-2"></i>Hourglass Data Export by Client/Resource</a>
        </div>
        <div class="my-2">
          <a href="https://reporting.welara.com/hourglass_weekly.aspx" target="_blank" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-print me-2"></i>Hourglass Weekly Report</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="card">
      <div class="card-header bg_blue">
        <span class="c_white mb-3"><i class="fas fa-fw fa-hourglass me-2"></i>Hourglass Tools</span>
      </div>
      <div class="card-body bg_bluelt">
        <div class="my-2">
          <a [routerLink]="'/taskcombine'" routerLinkActive="active" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-object-group me-2"></i>Task Combinator</a>
        </div>
        <div class="my-2">
          <a [routerLink]="'/billingreview'" routerLinkActive="active" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-dollar me-2"></i>Billing Review Tool</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="card">
      <div class="card-header bg_blue">
        <span class="c_white mb-3"><i class="fas fa-fw fa-cogs me-2"></i>System Tools</span>
      </div>
      <div class="card-body bg_bluelt">
        <div class="my-2">
          <a [routerLink]="'/minutes'" routerLinkActive="active" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-clock me-2"></i>MinutesMaker (Beta)</a>
        </div>
        <div class="my-2">
          <a href="https://reporting.welara.com/error_log.aspx" target="_blank" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-exclamation-triangle me-2"></i>WelaraOS Error Logs</a>
        </div>
        <div class="my-2">
          <a href="https://reporting.welara.com/rates.aspx" target="_blank" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-money me-2"></i>WelaraOS Billing Rates</a>
        </div>
        <div class="my-2">
          <a [routerLink]="'/plaid'" routerLinkActive="active" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-landmark me-2"></i>Plaid Link Tool</a>
        </div>
        <div class="my-2">
          <a [routerLink]="'/tools/tax-lots'" routerLinkActive="active" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-dollar-sign me-2"></i>Tax Lots Procedure</a>
        </div>
        <div class="my-2">
          <a [routerLink]="'/tools/token-ux'" routerLinkActive="active" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-key me-2"></i>Firebase Auth Token (Devs)</a>
        </div>
        <div class="my-2">
          <a [routerLink]="'/teams'" routerLinkActive="active" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-users me-2"></i>Teams Manager</a>
        </div>
        <div class="my-2">
          <a [routerLink]="'/tools/users'" routerLinkActive="active" *ngIf="authAdmin == 1"><i class="fas fa-fw fa-users me-2"></i>Users Manager</a>
        </div>
      </div>
    </div>
    

  </div>
</div>

